<template>
    <b-modal @ok='update' :no-close-on-backdrop="true" v-if='thread' centered ref="threadCodeEditDialog" :title="$t('translations.edit_codes')" size="xl" body-class="dialog-body-outer-scroll">
        <div>
            <div>
                <local-error v-bind:errors='errors' v-bind:inline='["codes.*", "blood_pressures.*"]'></local-error>
                
                <coding-list class='mb-1' :value='codes' :errors='errors' />
                <blood-pressure-list class='mb-1' :value='blood_pressures' :errors='errors' />
            </div>
        </div>
    </b-modal>
</template>


<script>

	export default {
        extends: app.base.attachmentHelper,
		props: {
            thread: {},
		},
		data: function(){
			return {
                codes: [],
                blood_pressures: [],
                errors: [],
			};
		},
		computed: {
            
		},
		watch: {
            // thread: function(val) {
            //     console.log("WATCH UPDATE", val);
            // }
		},
		created() {
        },
		beforeDestroy() {
		},
		mounted() {
            
		},

		methods: {
            hide() {
                this.$refs.threadCodeEditDialog.hide(); 
            },
            show() {
                this.errors = [];
                this.codes = this.copyNonReactive(this.thread.thread_code);
                this.blood_pressures = this.copyNonReactive(this.thread.blood_pressure);
                this.$refs.threadCodeEditDialog.show(); 
            },
            updateList() {
                this.codes = this.copyNonReactive(this.thread.thread_code);
                this.blood_pressures = this.copyNonReactive(this.thread.blood_pressure);
            },
            update(bvModalEvt) {
                bvModalEvt.preventDefault()
                this.$root.setLoading(true);
                this.errors = [];
                return axios.put(this.$root.apiBase + '/threads/updateCodes/' + this.thread.id, {
                        "codes": this.codes,
                        "blood_pressures": this.blood_pressures,
                }).then((res) => {
                    this.$root.setLoading(false);
                    this.hide();
                    return true;
                }).catch((error) => {
                    this.$root.setLoading(false);
                    this.handleError(error, "copy");
                    return false;
                });
            },
		}
    }
</script>
